import axios from "axios";
import { baseURL } from "../Constants";

const url = `${baseURL}/Discord`;

const authHeader = () => ({ Authorization: `Bearer ${localStorage.getItem("token")}` });

export interface DiscordStatus {
    linked: boolean;
    discordUsername: string | null;
    present: boolean;
    // Opt-in: whether the linked Discord is shown on the public player page.
    isPublic: boolean;
    // False while the feature is dark-launched (admin-only) — the UI hides the section when false.
    linkingEnabled: boolean;
}

// Current Discord link status for the logged-in user.
export const getDiscordStatus = async (): Promise<DiscordStatus | null> => {
    try {
        const response = await axios.get<DiscordStatus>(`${url}/me`, { headers: authHeader() });
        return response.data;
    } catch (error) {
        console.error("Error fetching Discord status:", error);
        return null;
    }
};

// Starts linking: returns the Discord authorize URL the browser should be redirected to.
export const startDiscordLink = async (): Promise<string | null> => {
    try {
        const response = await axios.post<{ authorizeUrl: string }>(`${url}/link/start`, {}, { headers: authHeader() });
        return response.data.authorizeUrl;
    } catch (error) {
        console.error("Error starting Discord link:", error);
        return null;
    }
};

export const unlinkDiscord = async (): Promise<boolean> => {
    try {
        await axios.post(`${url}/unlink`, {}, { headers: authHeader() });
        return true;
    } catch (error) {
        console.error("Error unlinking Discord:", error);
        return false;
    }
};

// Opt-in: show/hide the linked Discord on the public player page.
export const setDiscordVisibility = async (isPublic: boolean): Promise<boolean> => {
    try {
        await axios.post(`${url}/visibility`, { public: isPublic }, { headers: authHeader() });
        return true;
    } catch (error) {
        console.error("Error setting Discord visibility:", error);
        return false;
    }
};
